module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./mk-MK.coffee"));
	}, "locale/mk-MK");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=locale/[name]!./app/locale/mk-MK.coffee
// module id = 284
// module chunks = 97